/**
 * Observabilidade — wrapper leve para Sentry via window.Sentry (CDN).
 *
 * Não usa import() dinâmico para não quebrar o bundle do webpack.
 * Para ativar o Sentry, adicione o script CDN no public/index.html:
 *   <script src="https://browser.sentry-cdn.com/8.x.x/bundle.min.js"></script>
 * E defina REACT_APP_SENTRY_DSN no .env.
 *
 * Todos os métodos são no-ops se o Sentry não estiver disponível.
 */

function _S() {
  return (typeof window !== 'undefined' && window.Sentry) || null;
}

export function initObservability() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return;
  const S = _S();
  if (!S || typeof S.init !== 'function') return;
  S.init({
    dsn,
    environment: process.env.NODE_ENV || 'production',
    release: process.env.REACT_APP_VERSION || '1.0.0',
    tracesSampleRate: 0.2,
  });
}

export function setObservabilityUser({ id, email, tenant_id, role } = {}) {
  const S = _S();
  if (!S) return;
  if (typeof S.setUser === 'function') S.setUser({ id, email });
  if (typeof S.setTag === 'function') {
    S.setTag('tenant_id', tenant_id || 'unknown');
    S.setTag('role', role || 'unknown');
  }
}

export function clearObservabilityUser() {
  const S = _S();
  if (!S) return;
  if (typeof S.setUser === 'function') S.setUser(null);
}

export function captureError(error, context = {}) {
  const S = _S();
  if (!S) { console.error('[observability]', error, context); return; }
  if (typeof S.withScope === 'function') {
    S.withScope((scope) => {
      Object.entries(context).forEach(([k, v]) => scope.setExtra(k, v));
      if (typeof S.captureException === 'function') S.captureException(error);
    });
  }
}
